<template>
	<div class="video-list">
		<EventsSection
			:pagination="videos.pagination"
			:handle-pagination-change="handlePaginationChange"
			:events="videos.items"
			:is-loading="videos.isLoading"
			:show-results-counter="false"
		>
			<div
				v-if="showResultsCount"
				class="video-list__results-count"
			>
				{{ videos.pagination.total }} {{ $I18n.trans_choice('commons.video', videos.pagination.total) }}
			</div>
		</EventsSection>
	</div>
</template>

<script>
import EventsSection from '@js/components/EventListing/EventsSection';
import { EventFilter } from '@shared/enums/EventFilter';
import { httpClient } from '@shared/js/api/httpClient';

export default {
	name:       'VideoList',
	components: { EventsSection },
	props:      {
		contextFilter: {
			type:     Object,
			required: true,
		},
		eventFilters: {
			type:    Object,
			default: () => ({}),
		},
		externalSortOrder: {
			type:    Object,
			default: () => ({}),
		},
		showResultsCount: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			videos: {
				isLoading:  false,
				pagination: this.getInitialPagination(24),
				items:      [],
			},
		};
	},
	mounted() {
		this.getVideos();
	},
	methods: {
		handlePaginationChange(page) {
			this.videos.pagination.currentPage = page;
			this.getVideos();
		},
		async fetchData(searchParams) {
			const response = await httpClient.getEventsCached(Object.fromEntries(new URLSearchParams(searchParams)));
			return response.data;
		},
		async getVideos() {
			try {
				this.videos.isLoading = true;

				const searchParams = this.getSearchParams();
				const data = await this.fetchData(searchParams);
				this.videos.items = data.data;
				this.videos.pagination = data.meta;
			} catch (error) {
				// shows empty list
			} finally {
				this.videos.isLoading = false;
			}
		},
		getSearchParams() {
			const searchParams = new URLSearchParams();

			// filter(s) parameter
			const filters = { ...(this.eventFilters || {}) };
			filters[EventFilter.ARENA_AVAILABLE] = null;

			// Apply context filter
			filters[this.contextFilter.key] = this.contextFilter.value;

			searchParams.append('filters', JSON.stringify(filters));

			if (this.externalSortOrder && Object.keys(this.externalSortOrder).length > 0) {
				searchParams.append('sortOrder', JSON.stringify(this.externalSortOrder));
			}

			// pagination parameters
			searchParams.append('page', JSON.stringify(this.videos.pagination.currentPage));
			searchParams.append('perPage', JSON.stringify(this.videos.pagination.perPage));

			return searchParams;
		},
		getInitialPagination(perPage) {
			return {
				perPage:     perPage,
				currentPage: 1,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.video-list {
	margin-bottom: $sp7;

	@include size(md-up) {
		margin-bottom: $sp9;
	}
}

.video-list__results-count {
	@include font(primary, book, normal, fs-80);
	padding-top: $sp4;
	padding-bottom: $sp4;
	color: var(--color-grey-300);
	margin-bottom: 0;
}

</style>
